import { applyI18n, getCurrentLanguage, setLanguage, t } from './i18n.js';

const THEME_KEY = 'novij_stats_theme';
const THEMES = ['classic', 'midnight'];

export function initFooter() {
  initBuildVersion();
  initTheme();
  initLanguage();
  applyI18n();
}

function initBuildVersion() {
  const version = typeof __NOVIJ_BUILD_VERSION__ === 'string' ? __NOVIJ_BUILD_VERSION__ : '-';
  document.querySelectorAll('[data-ntp-build-version]').forEach((el) => {
    el.textContent = version;
    el.removeAttribute('data-version-placeholder');
  });
}

function initTheme() {
  applyTheme(readTheme());
  const button = document.querySelector('[data-action="toggle-theme"]');
  if (!button) return;
  button.addEventListener('click', () => {
    const current = readTheme();
    const next = THEMES[(THEMES.indexOf(current) + 1) % THEMES.length] || 'classic';
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (_) {}
    applyTheme(next);
  });
}

function initLanguage() {
  const select = document.getElementById('appFooterLanguage');
  if (!select) return;
  select.value = getCurrentLanguage();
  select.setAttribute('aria-label', t('common.language'));
  select.addEventListener('change', () => setLanguage(select.value));
}

function readTheme() {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (THEMES.includes(stored)) return stored;
  } catch (_) {}
  return 'classic';
}

function applyTheme(theme) {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  root.style.colorScheme = theme === 'midnight' ? 'dark' : 'light';
  const button = document.querySelector('[data-action="toggle-theme"]');
  if (button) button.setAttribute('data-theme-mode', theme);
}
